import { Stack, Divider, Typography, Box,  Button, Accordion, AccordionDetails, AccordionSummary } from "@mui/joy"
import { TileDownloadComponentZipVersion } from "../offlineUtils/offlineUtilFunctions"


const MapLibraryEntries =({MapDataInput, handleAccordionChange, expanded, handleNavChange,})=>{

    return (

<Accordion
                    expanded={expanded === MapDataInput.map}
                    onChange={handleAccordionChange(MapDataInput.map)}
                >
                <AccordionSummary >
                        <Stack  direction='column' sx={{padding:'4px'}} >

                        <Typography fontSize={17} fontWeight='bold' >{MapDataInput.mapName}</Typography>
                        
                        </Stack>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Stack >
                            <Divider width='90%'/>
                            <Box
                sx={{
                    width: '115%',
                    height: '200px',
                    overflow: 'hidden',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginLeft: '-7.5%',
                    marginRight: '-7.5%',
                }}
            >
                <img
                    src={MapDataInput.img}
                    alt='map thumbnail'
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center',
                    }}
                />
            </Box>
                        <Stack direction={'row'} spacing={3} px={1} py={1}>
                            <Stack spacing={1} >
                        <Stack spacing={-0.5}>
                            <Typography level='body-sm' fontWeight={'bold'}>Version</Typography>
                            <Typography level='body-sm'> {MapDataInput.version}</Typography>
                        </Stack>
                        <Stack spacing={-0.5}>
                            <Typography level='body-sm' fontWeight={'bold'}>Last Updated</Typography>
                            <Typography level='body-sm'> {MapDataInput.lastUpdated}</Typography>
                        </Stack>
                        <Stack spacing={-0.5}>
                            <Typography level='body-sm' fontWeight={'bold'}>Projection</Typography>
                            <Typography level='body-sm'> {MapDataInput.projection}</Typography>
                        </Stack>
                        </Stack>
                        <Stack spacing={1}>
                        <Stack spacing={-0.5}>
                            <Typography level='body-sm' fontWeight={'bold'}>Datum</Typography>
                            <Typography level='body-sm'> {MapDataInput.datum}</Typography>
                        </Stack>
                        <Stack spacing={-0.5}>
                            <Typography level='body-sm' fontWeight={'bold'}>Contour Interval</Typography>
                            <Typography level='body-sm'> {MapDataInput.contourInterval}</Typography>
                        </Stack>
                        <Stack spacing={-0.5}>
                            <Typography level='body-sm' fontWeight={'bold'}>Scale</Typography>
                            <Typography level='body-sm'>{MapDataInput.scale}</Typography>
                    </Stack>
                    </Stack>
                    </Stack>
                    <Stack direction='row' spacing={2}>
                    <Button  variant='outlined' color='neutral' onClick={()=>handleNavChange(MapDataInput.map)}>View</Button>
                    {MapDataInput.offlineAvailable &&
                    <TileDownloadComponentZipVersion maxBounds={MapDataInput.maxBounds} minZoom={MapDataInput.minZoom} maxZoom={MapDataInput.maxZoom} tileLayerBaseUrl={MapDataInput.tileLayerBaseUrl} tileRange={MapDataInput.tileRange} />
                    }
                    {MapDataInput.offlineComingSoon && 
                    <Button disabled variant='outlined' color='neutral'>Coming Soon....</Button>
                    }
                    </Stack>
                            </Stack>
                    </AccordionDetails>
                            
                </Accordion>
)}

export {MapLibraryEntries}